import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import moment from 'moment';
import {useParams} from "react-router-dom";
import ProfileTeacherPartApply from "@pages/profile/profile-teacher.part.apply";
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ManagerRegiPartAgency from "@pages/manager/manager-regi.part.agency";

const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileTeacherPage = () => {
  const defUrl = '/agmt'
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const account = useSelector(state => state.accountReducer)
  const navigate = useNavigate()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const {more} = useParams()
  const fields = [
    {field: 'id', placeholder: '데이터번호',    type:'text', value:-1, visible: more && (more === 'more'), disabled: false, canSrch:false, selList:[]},
    {field: 'schoolName', placeholder: ' 학교',    type:'text', value:'', visible: true, disabled: false, canSrch:false,selList:[]},
    {field: 'rltnCode', placeholder: '관계', type:'text', value:'', visible: false, disabled: false, canSrch:false,selList:[]},
    {field: 'rltnName', placeholder: '관계', type:'text', value:'', visible: true, disabled: false, canSrch:false,selList:[]},
    {field: 'companyName', placeholder: '위탁 업체', type:'text', value:'', visible: true, disabled: false, canSrch:false,selList:[]},
    {field: 'statCode', placeholder: '상태', type:'select', value:'', visible: false, disabled: false, canSrch:false,selList:['Y', 'N']},
    {field: 'statName', placeholder: '상태', type:'select', value:'', visible: true, disabled: false, canSrch:false,selList:['Y', 'N']},
  ]

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const recordRef = useRef(defRecord)

  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState(null)
  const [fieldList, set_fieldList] = useState([])
  const [companies, set_companies] = useState([])
  const [schoolList, set_schoolList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const applyHandler = useState(false)

  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  const onLoad = async() => {
    openIndicator()
    const schoolUserRelationList = await fetchSchoolUserRelationList()
    const schoolIdList = schoolUserRelationList.map(r => r.school.id)
    const companySchoolRelationList = await fetchCompanySchoolRelationList(schoolIdList)

    for(const r of schoolUserRelationList) {
      r.schoolName = r.school.name
      r.rltnName = getCodeName(codes, 'SA04', r.rltnCode)
      r.statName = getCodeName(codes, 'SA17', r.statCode)

      const found = companySchoolRelationList.find(c => c.school.id === r.school.id)

      if(found) {
        r.companyName = found.company.name
      }
      else {
        r.companyName = '없음'
      }
    }
    //
    
    set_dataList(schoolUserRelationList)
    const newFields = [...fields]
    set_fieldList(newFields)
    closeIndicator()
  }

  const fetchSchoolUserRelationList = async () => {
    const url = `/rltn/school/teacher/${account.user.id}`
    const resp = await WebService.get(url, {})
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const fetchCompanySchoolRelationList = async(schoolIdList) => {
    const url = `/rltn/company/schoolids/`
    const resp = await WebService.post(url, schoolIdList)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const onDelete = async(id) => {
    const url = defUrl
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    }
    else {
      openSnackbar(resp.repMessage)
    }
    
  }
  
  const onCreate = () => {
    const now = moment().format(dateFormat)
    const newRecord = {...defRecord, regTime: now, uptTime: now, schoolRltnList:[]}
    recordRef.current = newRecord
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }


  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage })
  }
  
  const handleChangeRowsPerPage = (event) => {
    
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum:0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }
  

  if(dataList != null) {
    return (
      <div >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>출강 학교 목록</h1>
          </div>
        </div>
        <div style={{display:'flex', flexDirection:'row'}}>
          <Button variant='outlined' color='primary' size='small' onClick={() => applyHandler[1](true)}>강사 등록 신청</Button>
        </div>
        
        <div style={{paddingTop:20}}>
          <MUITable>
            <MyTableHead >
              <TableRow>
                {
                  fieldList.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small' key={col.field}>
                          {col.placeholder}
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    value={terms[col.field]}
                                    onChange={(e) => {
                                      const newTerms = {...terms}
                                      newTerms[col.field] = e.target.value
                                      set_terms(newTerms)
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small'>
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList.map((row, index) => {
                  return(
                    <Fragment key={index}>
                      <TableRow onClick={()=> {
                        recordRef.current = row
                      }}>
                          {
                            fieldList.map((col, index2) => {
                              if(col.visible) {
                                return(
                                  <TableCell key={index2} size='small'>
                                    {row[col.field]}
                                  </TableCell>
                                )
                              }
                            })
                          }
                          <TableCell size='small'>
                          {/*
                          <FlatButton variant='outlined' size='small'  style={{marginRight:5}} onClick={() => onDetail(row.id)}>보기</FlatButton>
                          <FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>
                          */}
                            
                          </TableCell>
                        </TableRow>
                      </Fragment>
                  )
                })
              }
            </TableBody>
            <TableFooter>
            <TableRow>
            </TableRow>
          </TableFooter>
          </MUITable>
           {applyHandler[0] ? (<ProfileTeacherPartApply record={recordRef.current} relationList={dataList} dialogHandler={applyHandler} callback={onLoad} />) : null }
           {renderIndicator()}
          </div>
      </div>
    );
  }
  
}

export default ProfileTeacherPage
